module.exports = __webpack_public_path__ + "static/media/firebase.6caacd1a.svg";